import { toValue } from 'vue'

export function useRemoveManualDiscount () {
  function removeManualDiscount (orderItemToRemoveDiscount) {
    const orderItemToRemoveDiscountValue = toValue(orderItemToRemoveDiscount)
    const order = orderItemToRemoveDiscountValue.order

    if (orderItemToRemoveDiscountValue.manualDiscount && !_.isNil(orderItemToRemoveDiscountValue.discountGroupKey)) {
      const discountGroupKey = orderItemToRemoveDiscountValue.discountGroupKey
      for (const orderItem of order.unpaidOrderItems) {
        if (orderItem.discountGroupKey !== discountGroupKey) continue
        if (!orderItem.unpaid) continue

        orderItem.manualDiscount = false
        orderItem.discountId = null
        orderItem.discountGroupKey = null
        orderItem.forceApplyDiscountId = null
      }
    } else {
      orderItemToRemoveDiscountValue.manualDiscount = false
      orderItemToRemoveDiscountValue.discountGroupKey = null
      orderItemToRemoveDiscountValue.discountId = null
      orderItemToRemoveDiscountValue.forceApplyDiscountId = null
    }
  }

  return {
    removeManualDiscount
  }
}
